import { SIDEBAR_VIEWS, MAP_LAYER_IDS } from '../../../lib/constants';
import AlertCircle from '../../../assets/svg/Feather/AlertCircle'

export default (dispatch) => ({
  selectFeature: (selectedFeature) => {
    dispatch({
      type: 'features/setSelectedFeatureLoading',
      payload: true,
    });
    dispatch({
      type: 'features/setIsEditingFeature',
      payload: false,
    })
    dispatch({
      type: 'app/gotoSidebarWithHistory',
      payload: SIDEBAR_VIEWS.FeatureDetail,
    });
    dispatch({
      type: 'features/getFeature',
      payload: selectedFeature.uuid,
      callback: (feature, error) => {
        if (feature) {
          dispatch({
            type: 'features/setSelectedFeature',
            payload: feature,
          });
          dispatch({
            type: 'features/setPreviousFeatureState',
            payload: feature
          });
          dispatch({
            type: 'map/goToFeature',
            payload: {
              featureId: feature.uuid,
              layerId: MAP_LAYER_IDS.content,
            },
          });
        } else {
          dispatch({
            type: 'app/navSidebarBack'
          });
          dispatch({
            type: 'features/setSelectedFeature',
            payload: null
          });
          let toastPayloadText = 'Oops, there was an issue retrieving the feature'
          if (error.status == 404) {
            toastPayloadText = 'Sorry, but it looks like that feature does not exist'
            dispatch({
              type: 'features/removeFeatureFromUserDataEffect',
              payload: selectedFeature.uuid
            })
          }
          dispatch({
            type: 'toast/show',
            payload: {
              dismissable: true,
              icon: AlertCircle,
              iconColor: '#FF3B30',
              text: toastPayloadText,
            }
          });
        }
        dispatch({
          type: 'features/setSelectedFeatureLoading',
          payload: false,
        });
      },
    });
  },
  gotoLocationSidebar: (point, isSidebarClosed, layersAtLocation, overlaysAtLocation, county, state) => {
    dispatch({
      type: 'layers/setLayersAtLocation',
      payload: {
        county,
        layersAtLocation,
        overlaysAtLocation,
        point,
        state,
      },
    });

    if (isSidebarClosed) {
      dispatch({
        type: 'app/clearSidebarHistory',
      });
      dispatch({
        type: 'app/pushSidebarHistory',
        payload: {
          view: SIDEBAR_VIEWS.Layers,
        },
      });
      dispatch({
        type: 'app/gotoSidebar',
        payload: SIDEBAR_VIEWS.AboutLocation,
      });
    } else {
      dispatch({
        type: 'app/gotoSidebarWithHistory',
        payload: SIDEBAR_VIEWS.AboutLocation,
      });
    }
  },
});
